/**
 * Ensures every <style> element (SSR-inlined or client-injected) has the CSP nonce.
 * Fixes tags that have empty nonce and applies nonce to dynamically added styles (e.g. vue-style-loader).
 * createElement is patched earlier by csp-nonce-patch.client.js so style elements get nonce before content.
 */

import { getCspNonce } from '~/utils/styleToClass.js'

function setNonceOnStyle(el, nonce) {
  if (!el || el.tagName !== 'STYLE' || !nonce) return
  const current = el.getAttribute('nonce')
  if (current === nonce) return
  el.setAttribute('nonce', nonce)
}

function applyNonceToAllStyles(nonce) {
  if (!nonce) return
  document.querySelectorAll('style').forEach((el) => setNonceOnStyle(el, nonce))
}

function observeNewStyles(nonce) {
  if (!nonce || typeof MutationObserver === 'undefined') return
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && node.tagName === 'STYLE') {
          setNonceOnStyle(node, nonce)
        }
      }
    }
  })
  observer.observe(document.documentElement, { childList: true, subtree: true })
}

export default function () {
  if (!process.client) return
  const nonce = getCspNonce()
  if (!nonce) return
  applyNonceToAllStyles(nonce)
  observeNewStyles(nonce)
}
